import React, { createContext, useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { loadAllTranslations, changeLanguage } from '../i18n/translationsService';
import { getCurrentLanguage } from '../i18n/localStorage';
import { useSelector } from 'react-redux';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const user = useSelector((state) => state.user);
  const { i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [availableLanguages, setAvailableLanguages] = useState([
    { code: 'kz', name: 'Қазақша', shortName: 'Қаз' },
    { code: 'en', name: 'English', shortName: 'Eng'  },
    { code: 'ru', name: 'Русский', shortName: 'Рус' },
    { code: 'cn', name: '中文', shortName: '中文'  },
  ]);

  useEffect(() => {
    const initTranslations = async () => {
      try {
        setIsLoading(true);
        
        if (user.id) {
          await loadAllTranslations();
        }
        
        const savedLanguage = getCurrentLanguage();
        if (savedLanguage) {
          await changeLanguage(savedLanguage);
        }
        
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error('Ошибка при инициализации переводов:', err);
      } finally {
        setIsLoading(false);
      }
    };

    initTranslations();
  }, []);

  const handleChangeLanguage = async (language) => {
    try {
      setIsLoading(true);
      await changeLanguage(language);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const contextValue = {
    currentLanguage: i18n.language,
    availableLanguages,
    isLoading,
    error,
    changeLanguage: handleChangeLanguage
  };

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  
  if (!context) {
    throw new Error('useLanguage должен использоваться внутри LanguageProvider');
  }
  
  return context;
};